import { render, staticRenderFns } from "./viewAccountReceivable.vue?vue&type=template&id=5421ed90&scoped=true&"
import script from "./viewAccountReceivable.vue?vue&type=script&lang=js&"
export * from "./viewAccountReceivable.vue?vue&type=script&lang=js&"
import style0 from "./viewAccountReceivable.vue?vue&type=style&index=0&id=5421ed90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5421ed90",
  null
  
)

export default component.exports